class HelpscoutController {
  constructor(User, $state) {
    "ngInject";
    this.User = User;
    this.$state = $state;
  }

  saveApiKey() {
    this.connectLoading = true;
    this.User
      .connectHelpscout(this.apiKey)
      .then((response) => {
        if (response.status === 200) {
          this.showConnected = true;
          return this.getHelpscoutMailbox();
        }
        this.error = 'Failed to connect helpscout, Please check the api key and try again';
        this.connectLoading = false;

      })
      .catch((err) => {
        this.error = err.msg;
        this.connectLoading = false;
        console.log(err);
      })
  }

  getHelpscoutMailbox() {
    this
      .User
      .getHelpscoutMailbox()
      .then((response) => {
        this.loading = false;
        this.showPageSelect = true;
        this.mailboxes = response.data.mailboxes.items;
        this.selectedMailbox = this.mailboxes[0];
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }



  saveMailbox() {
    if (this.selectedMailbox && this.selectedMailbox.id) {
      this.saveMailboxLoading = true;
      this.User.saveMailbox({
          mailboxId: this.selectedMailbox.id
        }).then(() => {
          return this.User.updateUserOnboarding({
            helpscout: true
          })
        }).then(() => {
          this.saveMailboxLoading = false;
          this.$state.go('onboarding.facebook');
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
}

export default HelpscoutController;



// WEBPACK FOOTER //
// ./client/app/components/home/onboarding/helpscout/helpscout.controller.js